module.exports = __webpack_public_path__ + "static/media/openflowFirst.d7ff37cf.png";